/**
 * PATTEHUB - Premium Shopify Theme JavaScript
 * Handles: Cart, Cart Rewards, Quick View, Popup, FAQ, Mobile Menu,
 *          Scroll Animations, Toast, Language, Search, Countdown, Wishlist, Newsletter
 * Updated: May 2026 — Premium Refresh
 */

(function () {
  'use strict';

  /* ============================================================
     PRODUCT CATALOG (single source of truth — match by data-name)
     Prices in cents (€). image is path or 'art' (SVG-art card).
     ============================================================ */
  var PRODUCTS = {
    'Verhoogde Kattenbak':                              { id: 'cat-bowl',        variantId: 53817775391057, price: 2995, image: 'assets/cat-bowl.jpg',                                                                              handle: 'verhoogde-kattenbak' },
    'Slow Feeder Bowl':                                 { id: 'slow-feeder',     variantId: 53817775423825, price: 2795, image: 'assets/slow-feeder.jpg',                                                                           handle: 'slow-feeder-bowl' },
    'Snuffle Mat':                                      { id: 'snuffle-mat',     variantId: 53817775554897, price: 2995, image: 'assets/snuffle-mat.jpg',                                                                           handle: 'snuffle-mat' },
    'Pluche Hondenmand':                                { id: 'dog-bed',         variantId: 53817775587665, price: 4995, image: 'assets/dog-bed.jpg',                                                                               handle: 'pluche-hondenmand' },
    'Verkoelende Hondenmat':                            { id: 'cooling-mat',     variantId: 53817455411537, price: 3495, image: 'assets/cooling-mat-sora-thumb.webp',                                                               handle: 'verkoelende-hondenmat' },
    'Keramische Drinkfontein':                          { id: 'water-fountain',  variantId: null,           price: 4495, image: 'art:fount-bg',                                                                                     handle: null },
    'Kalmerende Donut Bed':                             { id: 'donut-bed',       variantId: null,           price: 5495, image: 'art:donut-bg',                                                                                     handle: null },
    'Neakasa P2 Dog Grooming Vacuum Kit':               { id: 'neakasa-p2',      variantId: 53882561593681, price: 8499, image: 'https://cdn.shopify.com/s/files/1/1018/7561/4033/files/p2_dog_grooming_kits_1.jpg?v=1779887404',   handle: 'neakasa-p2-dog-grooming-vacuum-kit' },
    'Pet Hair Removal Glove':                           { id: 'hair-glove',      variantId: 53883082572113, price:  999, image: 'https://cdn.shopify.com/s/files/1/1018/7561/4033/files/FunnyFuzzy_Pet_Hair_Removal_Glove_with_Dual-Sided_Electrostatic_Bristles_-8.jpg?v=1779890028', handle: 'pet-hair-removal-glove' },
    'SMARTPAWLite Automatische Pootenwasser':           { id: 'paw-washer',      variantId: 53883085291857, price: 4299, image: 'https://cdn.shopify.com/s/files/1/1018/7561/4033/files/DP1.jpg?v=1779890037',                     handle: 'smartpawlite-automatische-pootenwasser' },
    'Elektrische Nagelslijper voor Honden & Katten':    { id: 'nail-grinder',    variantId: 53883089027409, price: 3799, image: 'https://cdn.shopify.com/s/files/1/1018/7561/4033/files/white-black-pet-nail-grinder-usb-cable.png?v=1779890050', handle: 'elektrische-nagelslijper-voor-honden-katten' },
    'Breath-Reset Tandverzorging Watertoevoeging':      { id: 'breath-reset',    variantId: 53883090239825, price: 2499, image: 'https://cdn.shopify.com/s/files/1/1018/7561/4033/files/dental_wateradditive_01_final_02192026copy.jpg?v=1779890059', handle: 'breath-reset-tandverzorging-watertoevoeging-voor-honden' }
  };

  /* ============================================================
     REWARDS — thresholds & copy
     ============================================================ */
  var SHIP_THRESHOLD   = 5900;  // €59
  var BUNDLE_THRESHOLD = 2;     // 2+ items
  var BUNDLE_PCT       = 0.10;  // 10%

  /* ============================================================
     REWARDS ICONS
     ============================================================ */
  var ICONS = {
    truck: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M3 3h2l.4 2M7 13h10l4-8H5.4M7 13L5.4 5M7 13l-2.293 2.293A1 1 0 005.414 17H17"/><circle cx="9" cy="20" r="1.2"/><circle cx="17" cy="20" r="1.2"/></svg>',
    gift:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><polyline points="20 12 20 22 4 22 4 12"/><rect x="2" y="7" width="20" height="5"/><line x1="12" y1="22" x2="12" y2="7"/><path d="M12 7H7.5a2.5 2.5 0 010-5C11 2 12 7 12 7zM12 7h4.5a2.5 2.5 0 000-5C13 2 12 7 12 7z"/></svg>',
    spark: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8z"/><path d="M19 17l.8 2.2L22 20l-2.2.8L19 23l-.8-2.2L16 20l2.2-.8z"/></svg>',
    check: '<svg viewBox="0 0 24 24"><polyline points="20 6 9 17 4 12"/></svg>',
    lock:  '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V7a4 4 0 018 0v4"/></svg>'
  };

  function rewardIconKey(id) { return id === 'ship' ? 'truck' : 'gift'; }

  /* ============================================================
     PATTE OBJECT
     ============================================================ */
  var PATTE = {
    cart: [],
    cartOpen: false,
    popupShown: false,
    quickViewOpen: false,
    toastCount: 0,
    _toastTimer: null,
    mobileMenu: null,
    mobileToggle: null,

    _demoCart: {
      items: [],
      unlocked: { ship: false, bundle: false }
    },
    _prevUnlocked: { ship: false, bundle: false },

    /* ============================================================
       INIT
       ============================================================ */
    init() {
      this.loadCart();
      this.initHeader();
      this.initMobileMenu();
      this.initReveal();
      this.initFaq();
      this.initCountdown();
      this.initWishlist();
      this.initNewsletter();
      this.initPopup();
      this.initScrollAnimations();
      this.initCartDrawer();
      this.initLanguageSwitcher();
      this.initSearch();
      this.ensureCardHints();
    },

    /* ============================================================
       HEADER — scroll class + sticky ATC
       ============================================================ */
    initHeader() {
      const header = document.getElementById('header');
      if (!header) return;
      const onScroll = () => {
        if (window.scrollY > 8) header.classList.add('is-scrolled');
        else header.classList.remove('is-scrolled');
        const atc = document.getElementById('stickyAtc');
        if (atc) {
          if (window.scrollY > window.innerHeight * 0.9) atc.classList.add('is-show');
          else atc.classList.remove('is-show');
        }
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    },

    /* ============================================================
       SCROLL REVEAL — IntersectionObserver on .reveal elements
       ============================================================ */
    initReveal() {
      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      document.querySelectorAll('.reveal').forEach(el => io.observe(el));
      setTimeout(() => { const h = document.getElementById('hero'); if (h) h.classList.add('is-visible'); }, 50);
    },

    /* ============================================================
       MOBILE MENU — supports both new (#mobileMenu) and old (#mobile-menu) IDs
       ============================================================ */
    initMobileMenu() {
      this.mobileMenu = document.getElementById('mobileMenu') || document.getElementById('mobile-menu');
      const openBtns = document.querySelectorAll('#mobileMenuOpen, .header__mobile-toggle');
      const closeBtns = document.querySelectorAll('#mobileMenuClose, .mobile-menu__close');
      openBtns.forEach(btn => btn.addEventListener('click', () => {
        if (this.mobileMenu) {
          this.mobileMenu.classList.add('is-open');
          this.mobileMenu.setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        }
      }));
      closeBtns.forEach(btn => btn.addEventListener('click', () => {
        if (this.mobileMenu) {
          this.mobileMenu.classList.remove('is-open', 'active');
          this.mobileMenu.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      }));
    },

    toggleMobileMenu() {
      if (!this.mobileMenu) return;
      const isOpen = this.mobileMenu.classList.toggle('is-open');
      this.mobileMenu.classList.toggle('active', isOpen);
      this.mobileMenu.setAttribute('aria-hidden', String(!isOpen));
      document.body.style.overflow = isOpen ? 'hidden' : '';
    },

    closeMobileMenu() {
      if (!this.mobileMenu) return;
      this.mobileMenu.classList.remove('is-open', 'active');
      this.mobileMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },

    /* ============================================================
       CART — Shopify API methods
       ============================================================ */
    loadCart() {
      if (!window.routes || !window.routes.cart_url) return;
      fetch(window.routes.cart_url + '.js')
        .then(r => r.json())
        .then(cart => { this.cart = cart.items || []; this.updateCartUI(); })
        .catch(() => { this.cart = []; this.updateCartUI(); });
    },

    addToCart(variantId, btn) {
      if (!variantId) {
        this.showToast('Selecteer een optie eerst', 'error');
        return;
      }
      if (btn) {
        btn.disabled = true;
        btn.dataset.originalHtml = btn.innerHTML;
      }

      fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          this.loadCart();
          this.openCart();
          this.showToast((window.cartStrings && window.cartStrings.added) || 'Toegevoegd aan winkelmandje!', 'success');
          if (btn) {
            btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M20 6L9 17l-5-5"/></svg>';
            btn.style.background = 'var(--color-success)';
            setTimeout(() => {
              btn.innerHTML = btn.dataset.originalHtml;
              btn.style.background = '';
              btn.disabled = false;
            }, 1800);
          }
        })
        .catch(err => {
          console.error('Cart error:', err);
          this.showToast((window.cartStrings && window.cartStrings.error) || 'Kon niet toevoegen aan winkelmandje', 'error');
          if (btn) { btn.innerHTML = btn.dataset.originalHtml; btn.disabled = false; }
        });
    },

    removeFromCart(key) {
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
        .then(() => {
          this.loadCart();
          this.showToast('Item verwijderd', 'info');
        })
        .catch(() => this.showToast('Fout bij verwijderen', 'error'));
    },

    updateQuantity(key, qty) {
      if (qty < 1) { this.removeFromCart(key); return; }
      fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
        .then(() => this.loadCart())
        .catch(() => {});
    },

    clearCart() {
      fetch(window.routes.cart_clear_url + '.js', { method: 'POST' })
        .then(() => {
          this.loadCart();
          this.showToast('Winkelmandje leeggemaakt', 'info');
        })
        .catch(() => {
          const promises = this.cart.map(item =>
            fetch(window.routes.cart_change_url + '.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: item.key, quantity: 0 })
            })
          );
          Promise.all(promises).then(() => this.loadCart());
        });
    },

    updateCartUI() {
      const count = this.cart.reduce((s, i) => s + (i.quantity || 0), 0);
      document.querySelectorAll('#header-cart-count, #cart-count, #cartCount').forEach(el => {
        if (el) el.textContent = count;
      });
      this.renderCartDrawer();
    },

    renderCartDrawer() {
      const content = document.getElementById('cart-drawer__content');
      if (!content) return;

      if (!this.cart || this.cart.length === 0) {
        content.innerHTML = `
          <div class="cart-empty">
            <svg width="72" height="72" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" class="cart-empty__icon"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
            <p class="cart-empty__title">${(window.cartStrings && window.cartStrings.empty) || 'Je winkelmandje is leeg'}</p>
            <p class="cart-empty__text">${(window.cartStrings && window.cartStrings.continueShopping) || 'Ontdek onze producten!'}</p>
            <button class="btn btn--primary" onclick="PATTE.closeCart()">${(window.cartStrings && window.cartStrings.continueShopping) || 'Verder winkelen'}</button>
          </div>`;
        return;
      }

      let subtotal = 0;
      const items = this.cart.map(item => {
        const price = item.final_line_price || (item.price * item.quantity) || 0;
        subtotal += price;
        return this.renderCartItem(item);
      }).join('');

      const discountPct = this.cart.length >= 3 ? 15 : this.cart.length >= 2 ? 10 : 0;
      const discount = Math.round(subtotal * discountPct / 100);
      const finalTotal = subtotal - discount;
      const freeShipThreshold = 5900;
      const freeShipping = finalTotal >= freeShipThreshold;

      let html = '<div class="cart-items">' + items + '</div>';

      if (freeShipping) {
        html += `<div class="shipping-bar shipping-bar--free">
          <svg class="shipping-bar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#4A7C59" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
          <span class="shipping-bar__text">Gratis verzending!</span>
        </div>`;
      } else {
        const remaining = freeShipThreshold - finalTotal;
        html += `<div class="shipping-bar shipping-bar--progress">
          <svg class="shipping-bar__icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#D4946A" stroke-width="2"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg>
          <span class="shipping-bar__text">Nog ${this.formatMoney(remaining)} voor gratis verzending</span>
        </div>`;
      }

      html += '<div class="cart-summary">';
      html += `<div class="cart-summary__row"><span>Subtotaal</span><span>${this.formatMoney(subtotal)}</span></div>`;
      if (discount > 0) {
        html += `<div class="cart-summary__row cart-summary__row--discount"><span>${discountPct}% bundelkorting</span><span>-${this.formatMoney(discount)}</span></div>`;
      }
      html += `<div class="cart-summary__row"><span>Verzending</span><span>${freeShipping ? '<span style="color:var(--c-primary)">Gratis</span>' : this.formatMoney(495)}</span></div>`;
      const grandTotal = finalTotal + (freeShipping ? 0 : 495);
      html += `<div class="cart-summary__row cart-summary__row--total"><span>Totaal</span><span>${this.formatMoney(grandTotal)}</span></div>`;
      html += `<a href="/checkout" class="btn btn--primary btn--full cart-summary__checkout">Afrekenen</a>`;
      html += '</div>';

      content.innerHTML = html;
    },

    renderCartItem(item) {
      const img = item.image || (item.featured_image && item.featured_image.url) || '';
      const title = item.product_title || item.title || '';
      const variant = item.variant_title || '';
      const price = item.final_price || item.price || 0;
      return `<div class="cart-item">
        <img src="${img}" alt="${title}" class="cart-item__image" loading="lazy">
        <div class="cart-item__details">
          <h4 class="cart-item__title">${title}</h4>
          ${variant ? `<p class="cart-item__variant">${variant}</p>` : ''}
          <p class="cart-item__price">${this.formatMoney(price)}</p>
          <div class="cart-item__actions">
            <div class="cart-item__qty">
              <button onclick="PATTE.updateQuantity('${item.key}', ${item.quantity - 1})" aria-label="Verlaag aantal"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
              <span>${item.quantity}</span>
              <button onclick="PATTE.updateQuantity('${item.key}', ${item.quantity + 1})" aria-label="Verhoog aantal"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg></button>
            </div>
            <button class="cart-item__remove" onclick="PATTE.removeFromCart('${item.key}')" aria-label="Verwijder">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a2 2 0 012-2h4a2 2 0 012 2v2"/></svg>
            </button>
          </div>
        </div>
      </div>`;
    },

    /* ============================================================
       OPEN / CLOSE CART — supports both new and old IDs
       ============================================================ */
    openCart() {
      this.cartOpen = true;
      document.getElementById('cartDrawer')?.classList.add('is-open');
      document.getElementById('cartOverlay')?.classList.add('is-open');
      document.getElementById('cart-drawer')?.classList.add('active');
      document.getElementById('cart-overlay')?.classList.add('active');
      document.body.style.overflow = 'hidden';
    },

    closeCart() {
      this.cartOpen = false;
      document.getElementById('cartDrawer')?.classList.remove('is-open');
      document.getElementById('cartOverlay')?.classList.remove('is-open');
      document.getElementById('cart-drawer')?.classList.remove('active');
      document.getElementById('cart-overlay')?.classList.remove('active');
      document.body.style.overflow = '';
    },

    /* ============================================================
       CART DRAWER INIT + REWARDS SYSTEM
       ============================================================ */
    initCartDrawer() {
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          this.closeCart();
          this.closeQuickView();
          this.closePopup();
        }
      });

      const cartBtn = document.getElementById('cartBtn');
      if (cartBtn) cartBtn.addEventListener('click', () => this.openCart());

      const cartClose = document.getElementById('cartClose');
      if (cartClose) cartClose.addEventListener('click', () => this.closeCart());

      const cartOverlay = document.getElementById('cartOverlay');
      if (cartOverlay) cartOverlay.addEventListener('click', () => this.closeCart());

      document.querySelectorAll('.js-atc').forEach(b => {
        b.addEventListener('click', () => {
          this.addByName(b.getAttribute('data-name'));
        });
      });

      this._renderRewardsCart();
    },

    /* ============================================================
       REWARDS CART — demo / prototype cart with rewards system
       ============================================================ */
    _money(cents) {
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    },

    _itemCount() {
      return this._demoCart.items.reduce(function (s, i) { return s + i.qty; }, 0);
    },

    _subtotal() {
      return this._demoCart.items.reduce(function (s, i) { return s + i.price * i.qty; }, 0);
    },

    computeRewards() {
      var sub = this._subtotal(), count = this._itemCount();
      var ship = {
        id: 'ship',
        title: 'Gratis verzending',
        threshold: SHIP_THRESHOLD,
        unlocked: sub >= SHIP_THRESHOLD,
        remain: Math.max(0, SHIP_THRESHOLD - sub),
        progress: Math.min(1, sub / SHIP_THRESHOLD),
        value: 'GRATIS',
        hintLocked: 'Nog ' + this._money(Math.max(0, SHIP_THRESHOLD - sub)) + ' tot gratis verzending',
        hintUnlocked: 'Wij betalen je verzending — DHL Climate Neutral'
      };
      var bundle = {
        id: 'bundle',
        title: 'Zomerbundel · 10% korting',
        threshold: BUNDLE_THRESHOLD,
        unlocked: count >= BUNDLE_THRESHOLD,
        remain: Math.max(0, BUNDLE_THRESHOLD - count),
        progress: Math.min(1, count / BUNDLE_THRESHOLD),
        value: '−10%',
        hintLocked: 'Voeg nog ' + Math.max(0, BUNDLE_THRESHOLD - count) + ' product' + (BUNDLE_THRESHOLD - count === 1 ? '' : 'en') + ' toe',
        hintUnlocked: '10% wordt automatisch toegepast op je subtotaal'
      };
      return { ship: ship, bundle: bundle };
    },

    computeDiscount() {
      var r = this.computeRewards();
      var d = 0;
      if (r.bundle.unlocked) d += Math.round(this._subtotal() * BUNDLE_PCT);
      return d;
    },

    computeShipping() {
      if (this._demoCart.items.length === 0) return 0;
      return this.computeRewards().ship.unlocked ? 0 : 495;
    },

    computeTotal() {
      return Math.max(0, this._subtotal() - this.computeDiscount() + this.computeShipping());
    },

    addByName(name) {
      var meta = PRODUCTS[name];
      if (!meta) { console.warn('Unknown product:', name); return; }
      var existing = this._demoCart.items.find(function (i) { return i.id === meta.id; });
      if (existing) existing.qty++;
      else this._demoCart.items.push({ id: meta.id, name: name, price: meta.price, image: meta.image, qty: 1 });
      this.showToast('❖ ' + name + ' toegevoegd');
      this._renderRewardsCart();
      this.openCart();
      if (meta.variantId) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: meta.variantId, quantity: 1 })
        }).catch(function(e) { console.warn('Cart sync failed:', e); });
      }
    },

    setQty(id, qty) {
      var it = this._demoCart.items.find(function (i) { return i.id === id; });
      if (!it) return;
      if (qty <= 0) { this._demoCart.items = this._demoCart.items.filter(function (i) { return i.id !== id; }); }
      else { it.qty = qty; }
      this._renderRewardsCart();
    },

    checkout() {
      var r = this.computeRewards();
      var codes = [];
      if (r.ship.unlocked)   codes.push('FREESHIP59');
      if (r.bundle.unlocked) codes.push('ZOMER10');
      var url = '/checkout' + (codes.length ? '?discount=' + codes.join(',') : '');
      window.location.href = url;
    },

    _stickyHintMessage(r) {
      if (!r.ship.unlocked && this._demoCart.items.length > 0) return 'Nog ' + this._money(r.ship.remain) + ' tot gratis verzending';
      if (!r.bundle.unlocked && this._demoCart.items.length === 1) return 'Voeg 1 product toe → 10% zomerbundel';
      return '';
    },

    cardHintFor(name, r) {
      var meta = PRODUCTS[name]; if (!meta) return '';
      var sub = this._subtotal(), count = this._itemCount();
      var inCart = this._demoCart.items.some(function (i) { return i.id === meta.id; });

      if (!r.ship.unlocked && sub > 0 && sub + meta.price >= SHIP_THRESHOLD)
        return 'Voeg toe en ontgrendel <b>gratis verzending</b>';

      if (!r.bundle.unlocked && count === BUNDLE_THRESHOLD - 1 && !inCart)
        return 'Voeg toe en ontgrendel <b>10% zomerbundel</b>';

      if (sub === 0) return 'Voeg toe en ontgrendel <b>jouw zomervoordeel</b>';
      return '';
    },

    ensureCardHints() {
      document.querySelectorAll('.products .card').forEach(card => {
        if (card.classList.contains('card--discover')) return;
        if (card.querySelector('.card__hint')) return;
        var btn = card.querySelector('.js-atc');
        if (!btn) return;
        var hint = document.createElement('div');
        hint.className = 'card__hint';
        hint.setAttribute('data-name', btn.getAttribute('data-name'));
        hint.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor"><path d="M12 2l1.8 5.2L19 9l-5.2 1.8L12 16l-1.8-5.2L5 9l5.2-1.8z"/></svg><span></span>';
        var body = card.querySelector('.card__body');
        if (body) body.appendChild(hint);
      });
    },

    updateCardHints(r) {
      document.querySelectorAll('.card__hint').forEach(el => {
        var name = el.getAttribute('data-name');
        var msg = this.cardHintFor(name, r);
        var span = el.querySelector('span');
        if (msg) { span.innerHTML = msg; el.classList.add('is-show'); }
        else { el.classList.remove('is-show'); }
      });
    },

    _renderRewardsCart() {
      var r = this.computeRewards();
      var sub = this._subtotal();
      var count = this._itemCount();

      var cartCountEl = document.getElementById('cartCount');
      if (cartCountEl) cartCountEl.textContent = count;
      var cartTitleCount = document.getElementById('cartTitleCount');
      if (cartTitleCount) cartTitleCount.textContent = '(' + count + ')';

      var sa = document.getElementById('stickyAtc');
      if (sa) {
        var hintEl = sa.querySelector('.sticky-atc__hint');
        if (!hintEl) {
          hintEl = document.createElement('div');
          hintEl.className = 'sticky-atc__hint';
          var saDiv = sa.querySelector('div');
          if (saDiv) saDiv.appendChild(hintEl);
        }
        var msg = this._stickyHintMessage(r);
        if (msg) { sa.classList.add('has-hint'); hintEl.textContent = msg; }
        else sa.classList.remove('has-hint');
      }

      var cartRewardsEl = document.getElementById('cartRewards');
      if (cartRewardsEl) {
        var primary = !r.ship.unlocked ? r.ship : !r.bundle.unlocked ? r.bundle : r.ship;
        var labelHTML, remainHTML, fillPct;

        if (primary.id === 'ship') {
          if (primary.unlocked) {
            labelHTML = '<em>✓</em> Gratis verzending <em>ontgrendeld</em>';
            remainHTML = 'KLAAR';
            fillPct = 100;
          } else {
            labelHTML = 'Nog <em>' + this._money(primary.remain) + '</em> tot jouw zomervoordeel';
            remainHTML = Math.round(primary.progress * 100) + '% klaar';
            fillPct = primary.progress * 100;
          }
        } else {
          if (primary.unlocked) {
            labelHTML = '<em>✓</em> Zomerbundel <em>ontgrendeld</em>';
            remainHTML = 'KLAAR';
            fillPct = 100;
          } else {
            labelHTML = 'Nog <em>' + primary.remain + '</em> ' + (primary.remain === 1 ? 'product' : 'producten') + ' tot 10% zomerbundel';
            remainHTML = count + '/' + BUNDLE_THRESHOLD;
            fillPct = primary.progress * 100;
          }
        }

        if (this._demoCart.items.length === 0) {
          labelHTML = 'Start <em>jouw winkelmandje</em>';
          remainHTML = '';
          fillPct = 0;
        }

        var rewardsHTML = '';
        rewardsHTML += '<div class="cart-progress ' + (fillPct >= 100 ? 'is-complete' : '') + '">';
        rewardsHTML += '  <div class="cart-progress__head">';
        rewardsHTML += '    <div class="cart-progress__label">' + labelHTML + '</div>';
        if (remainHTML) rewardsHTML += '    <div class="cart-progress__remain">' + remainHTML + '</div>';
        rewardsHTML += '  </div>';
        rewardsHTML += '  <div class="cart-progress__track"><div class="cart-progress__fill" style="width:' + fillPct + '%"></div></div>';
        rewardsHTML += '</div>';

        rewardsHTML += '<div class="reward-list">';
        [r.ship, r.bundle].forEach(rw => {
          var classes = 'reward';
          classes += rw.unlocked ? ' is-unlocked' : ' is-locked';
          if (rw.unlocked && !this._prevUnlocked[rw.id]) classes += ' is-just-unlocked';
          var iconKey = rewardIconKey(rw.id);
          rewardsHTML += '<div class="' + classes + '" data-reward="' + rw.id + '">';
          rewardsHTML += '  <div class="reward__check">' + (rw.unlocked ? ICONS.check : ICONS[iconKey]) + '</div>';
          rewardsHTML += '  <div class="reward__body">';
          rewardsHTML += '    <div class="reward__title">' + (rw.unlocked ? '✓ ' + rw.title + ' ontgrendeld' : rw.title) + '</div>';
          rewardsHTML += '    <div class="reward__hint">' + (rw.unlocked ? rw.hintUnlocked : rw.hintLocked) + '</div>';
          rewardsHTML += '  </div>';
          rewardsHTML += '  <div class="reward__value">' + rw.value + '</div>';
          rewardsHTML += '</div>';
        });
        rewardsHTML += '</div>';
        cartRewardsEl.innerHTML = rewardsHTML;

        ['ship', 'bundle'].forEach(id => {
          var rw = r[id];
          if (rw.unlocked && !this._prevUnlocked[id]) {
            this.showToast('✓ Beloning ontgrendeld — ' + rw.title);
          }
        });
        this._prevUnlocked = { ship: r.ship.unlocked, bundle: r.bundle.unlocked };
      }

      var itemsEl = document.getElementById('cartItems');
      if (itemsEl) {
        if (this._demoCart.items.length === 0) {
          itemsEl.innerHTML =
            '<div class="cart-empty">' +
            '<div class="cart-empty__icon"><svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></div>' +
            '<div class="cart-empty__title">Je winkelmandje is leeg</div>' +
            '<div class="cart-empty__sub">Ontdek onze zomercollectie en ontgrendel beloningen.</div>' +
            '<button class="btn btn--primary" onclick="window.PATTE.closeCart()">Begin met shoppen</button>' +
            '</div>';
        } else {
          var html = '';
          this._demoCart.items.forEach(it => {
            var imgHTML = it.image && it.image.indexOf('art:') === 0
              ? '<svg viewBox="0 0 1 1" preserveAspectRatio="xMidYMid slice"><rect width="1" height="1" fill="' + (it.image === 'art:cool-bg' ? '#D5DDDC' : it.image === 'art:fount-bg' ? '#E8DCC4' : '#E2D2B0') + '"/></svg>'
              : '<img src="' + it.image + '" alt="' + it.name + '">';
            html += '<div class="cart-item">';
            html += '  <div class="cart-item__img">' + imgHTML + '</div>';
            html += '  <div class="cart-item__body">';
            html += '    <div class="cart-item__head"><div class="cart-item__name">' + it.name + '</div><div class="cart-item__price">' + this._money(it.price * it.qty) + '</div></div>';
            html += '    <div class="cart-item__meta">' + this._money(it.price) + ' per stuk · op voorraad</div>';
            html += '    <div class="cart-item__foot">';
            html += '      <div class="cart-item__qty">';
            html += '        <button data-q-dec="' + it.id + '" aria-label="Minder"><svg viewBox="0 0 24 24"><path d="M5 12h14"/></svg></button>';
            html += '        <span>' + it.qty + '</span>';
            html += '        <button data-q-inc="' + it.id + '" aria-label="Meer"><svg viewBox="0 0 24 24"><path d="M12 5v14M5 12h14"/></svg></button>';
            html += '      </div>';
            html += '      <button class="cart-item__remove" data-q-rm="' + it.id + '">Verwijder</button>';
            html += '    </div>';
            html += '  </div>';
            html += '</div>';
          });
          itemsEl.innerHTML = html;
          itemsEl.querySelectorAll('[data-q-inc]').forEach(b => {
            b.onclick = () => { var id = b.getAttribute('data-q-inc'); var it = this._demoCart.items.find(i => i.id === id); this.setQty(id, it.qty + 1); };
          });
          itemsEl.querySelectorAll('[data-q-dec]').forEach(b => {
            b.onclick = () => { var id = b.getAttribute('data-q-dec'); var it = this._demoCart.items.find(i => i.id === id); this.setQty(id, it.qty - 1); };
          });
          itemsEl.querySelectorAll('[data-q-rm]').forEach(b => {
            b.onclick = () => { this.setQty(b.getAttribute('data-q-rm'), 0); };
          });
        }
      }

      var footEl = document.getElementById('cartFoot');
      if (footEl) {
        if (this._demoCart.items.length === 0) {
          footEl.innerHTML = '';
        } else {
          var disc = this.computeDiscount();
          var ship = this.computeShipping();
          var total = this.computeTotal();
          var codes = [];
          if (r.ship.unlocked)   codes.push({ tag: 'FREESHIP59', label: 'Verzending' });
          if (r.bundle.unlocked) codes.push({ tag: 'ZOMER10',    label: 'Zomerbundel' });

          var fh = '<div class="cart-foot__lines">';
          fh += '<div class="cart-foot__row"><span>Subtotaal</span><span>' + this._money(sub) + '</span></div>';
          if (r.bundle.unlocked) {
            fh += '<div class="cart-foot__row cart-foot__row--discount"><span><span>Zomerbundel</span><span class="cart-foot__tag">−10% toegepast</span></span><span>−' + this._money(Math.round(sub * BUNDLE_PCT)) + '</span></div>';
          }
          fh += '<div class="cart-foot__row"><span>Verzending</span><span>' + (ship === 0 ? '<strong style="color:var(--c-primary)">Gratis</strong>' : this._money(ship)) + '</span></div>';
          fh += '<div class="cart-foot__row cart-foot__row--total"><span>Totaal</span><span>' + this._money(total) + '</span></div>';
          fh += '</div>';
          fh += '<button class="cart-foot__cta" onclick="window.PATTE.checkout()">Doorgaan naar checkout <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M12 5l7 7-7 7"/></svg></button>';
          if (codes.length) {
            fh += '<div class="cart-foot__codes">';
            codes.forEach(c => { fh += '<span class="cart-foot__code">✓ ' + c.tag + '</span>'; });
            fh += '</div>';
          }
          fh += '<div class="cart-foot__note"><svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"/><path d="M7 11V7a5 5 0 0110 0v4"/></svg> Veilig betalen · iDEAL, Klarna, Apple Pay</div>';
          footEl.innerHTML = fh;
        }
      }

      this.updateCardHints(r);
    },

    /* ============================================================
       QUICK VIEW
       ============================================================ */
    openQuickView(product) {
      const modal = document.getElementById('quick-view-modal');
      const overlay = document.getElementById('quick-view-overlay');
      const content = document.getElementById('quick-view__content');
      if (!modal || !content) return;

      content.innerHTML = `
        <div class="quickview">
          <div class="quickview__image">
            <img src="${product.image}" alt="${product.title}" loading="eager">
          </div>
          <div class="quickview__details">
            <h3 class="quickview__title">${product.title}</h3>
            <div class="quickview__price">
              <span class="quickview__price-current">${product.price}</span>
              ${product.compare_price ? `<span class="quickview__price-compare">${product.compare_price}</span>` : ''}
            </div>
            <div class="quickview__badge">
              ${product.badge ? `<span class="quickview__badge-item" style="background:${product.badge_color || 'var(--c-accent)'};color:white">${product.badge}</span>` : ''}
              ${product.tags ? product.tags.split(',').map(t => `<span class="quickview__badge-item" style="background:var(--c-primary-light);color:var(--c-primary)">${t.trim()}</span>`).join('') : ''}
            </div>
            <p class="quickview__desc">${product.description || ''}</p>
            <div class="quickview__actions">
              <button class="btn btn--primary btn--large btn--full" onclick="PATTE.addToCart('${product.variant_id}', this)">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg>
                In winkelwagen
              </button>
            </div>
          </div>
        </div>`;

      modal.classList.add('active');
      overlay?.classList.add('active');
      document.body.style.overflow = 'hidden';
      this.quickViewOpen = true;
    },

    closeQuickView() {
      this.quickViewOpen = false;
      document.getElementById('quick-view-modal')?.classList.remove('active');
      document.getElementById('quick-view-overlay')?.classList.remove('active');
      if (!this.cartOpen) document.body.style.overflow = '';
    },

    /* ============================================================
       FAQ — accordion (single-open) + category filter
       ============================================================ */
    initFaq() {
      const faqList = document.getElementById('faqList');
      if (!faqList) return;
      faqList.querySelectorAll('details').forEach(d => {
        d.addEventListener('toggle', () => {
          if (d.open) {
            d.classList.add('is-open');
            faqList.querySelectorAll('details').forEach(o => { if (o !== d) { o.open = false; o.classList.remove('is-open'); } });
          } else d.classList.remove('is-open');
        });
      });
      const cats = document.getElementById('faqCats');
      if (cats) cats.addEventListener('click', e => {
        const b = e.target.closest('.faq__cat');
        if (!b) return;
        document.querySelectorAll('.faq__cat').forEach(x => x.classList.remove('is-active'));
        b.classList.add('is-active');
        const cat = b.getAttribute('data-cat');
        faqList.querySelectorAll('details').forEach(d => {
          d.style.display = (cat === 'all' || d.getAttribute('data-cat') === cat) ? '' : 'none';
        });
      });
    },

    toggleFaq(btn) {
      const item = btn.closest('[data-faq-item]');
      const wasActive = item.classList.contains('active');
      document.querySelectorAll('[data-faq-item]').forEach(i => i.classList.remove('active'));
      if (!wasActive) item.classList.add('active');
    },

    /* ============================================================
       POPUP
       ============================================================ */
    initPopup() {
      const popup = document.getElementById('patte-popup');
      if (!popup) return;
      if (sessionStorage.getItem('patte-popup-dismissed')) return;

      const delay = parseInt(popup.dataset.delay || '5', 10) * 1000;

      setTimeout(() => {
        if (!this.popupShown) this.showPopup();
      }, delay);

      document.addEventListener('mouseout', (e) => {
        if (!this.popupShown && e.clientY < 10) this.showPopup();
      });
    },

    showPopup() {
      const popup = document.getElementById('patte-popup');
      if (!popup) return;
      popup.style.display = 'flex';
      this.popupShown = true;
    },

    closePopup() {
      const popup = document.getElementById('patte-popup');
      if (!popup) return;
      const content = popup.querySelector('.popup__content');
      if (content) content.classList.add('closing');
      setTimeout(() => {
        popup.style.display = 'none';
        sessionStorage.setItem('patte-popup-dismissed', 'true');
      }, 300);
    },

    /* ============================================================
       COUNTDOWN TIMER — persists 30-day deadline in localStorage
       ============================================================ */
    initCountdown() {
      const STORE_KEY = 'pattehub_sale_deadline_v1';
      let deadline = parseInt(localStorage.getItem(STORE_KEY), 10);
      if (!deadline || isNaN(deadline) || deadline < Date.now()) {
        deadline = Date.now() + 30 * 24 * 60 * 60 * 1000;
        localStorage.setItem(STORE_KEY, String(deadline));
      }
      const $d = document.getElementById('cdDays'), $h = document.getElementById('cdHours'),
            $m = document.getElementById('cdMinutes'), $s = document.getElementById('cdSeconds');
      if (!$d) return;
      const pad = n => n < 10 ? '0' + n : '' + n;
      const tick = () => {
        const diff = Math.max(0, deadline - Date.now());
        $d.textContent = pad(Math.floor(diff / 86400000));
        $h.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        $m.textContent = pad(Math.floor((diff % 3600000) / 60000));
        $s.textContent = pad(Math.floor((diff % 60000) / 1000));
      };
      tick(); setInterval(tick, 1000);
    },

    /* ============================================================
       WISHLIST — toggle .is-on on .card__wish buttons
       ============================================================ */
    initWishlist() {
      document.addEventListener('click', e => {
        const btn = e.target.closest('.card__wish');
        if (!btn) return;
        btn.classList.toggle('is-on');
      });
    },

    /* ============================================================
       NEWSLETTER FORM
       ============================================================ */
    initNewsletter() {
      document.querySelectorAll('.newsletter__form').forEach(form => {
        form.addEventListener('submit', e => {
          e.preventDefault();
          this.showToast('Welkom bij de club ❖ Check je inbox.');
        });
      });
    },

    /* ============================================================
       TOAST — supports new (#toast) and old (#toast-container) styles
       ============================================================ */
    showToast(msg, type) {
      const t = document.getElementById('toast');
      if (t) {
        const txt = document.getElementById('toastText');
        if (txt) txt.textContent = msg;
        t.classList.add('is-show');
        clearTimeout(this._toastTimer);
        this._toastTimer = setTimeout(() => t.classList.remove('is-show'), 3000);
        return;
      }
      const container = document.getElementById('toast-container');
      if (!container) return;
      const el = document.createElement('div');
      el.className = `toast toast--${type || 'success'} toast--show`;
      el.innerHTML = `<span>${msg}</span>`;
      container.appendChild(el);
      setTimeout(() => { el.remove(); }, 3500);
    },

    /* ============================================================
       LANGUAGE SWITCHER
       ============================================================ */
    initLanguageSwitcher() {
      document.addEventListener('click', (e) => {
        const switcher = e.target.closest('.lang-switcher');
        if (!switcher) {
          document.querySelectorAll('.lang-switcher__dropdown').forEach(d => d.classList.remove('active'));
        }
      });
    },

    toggleLang() {
      const dd = document.getElementById('lang-dropdown');
      if (dd) dd.classList.toggle('active');
    },

    setLang(lang) {
      localStorage.setItem('patte-lang', lang);
      const dd = document.getElementById('lang-dropdown');
      if (dd) dd.classList.remove('active');
      const codeEl = document.querySelector('.lang-switcher__code');
      if (codeEl) codeEl.textContent = lang.toUpperCase();
    },

    /* ============================================================
       SEARCH — predictive search
       ============================================================ */
    initSearch() {
      const input = document.querySelector('.header__search-input');
      if (!input) return;

      let debounceTimer;
      input.addEventListener('input', (e) => {
        clearTimeout(debounceTimer);
        const query = e.target.value.trim();
        if (query.length < 2) return;
        debounceTimer = setTimeout(() => this.searchPredictive(query), 300);
      });
    },

    searchPredictive(query) {
      if (!window.routes || !window.routes.predictive_search_url) return;
      fetch(`${window.routes.predictive_search_url}?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5&section_id=predictive-search`)
        .then(r => r.text())
        .then(html => {
          const results = document.getElementById('search-results');
          if (results) results.innerHTML = html;
        })
        .catch(() => {});
    },

    /* ============================================================
       SCROLL ANIMATIONS (legacy — adds .visible class)
       ============================================================ */
    initScrollAnimations() {
      const els = document.querySelectorAll('.reveal');
      if (!els.length) return;
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
      els.forEach(el => observer.observe(el));
    },

    /* ============================================================
       UTILITIES
       ============================================================ */
    formatMoney(cents) {
      if (typeof cents === 'string') cents = parseInt(cents, 10);
      return '€' + (cents / 100).toFixed(2).replace('.', ',');
    },

    formatDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleDateString('nl-NL', { day: 'numeric', month: 'long', year: 'numeric' });
    },

    scrollToTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  window.PATTE = PATTE;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => PATTE.init());
  } else {
    PATTE.init();
  }
})();
